var _colors$purple700$mat, _colors$purple800$mat;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useMemo, useState } from 'react';
import { isNumber } from 'lodash-es';
import { makeStyles, Slider } from 'seagull';
import colors from 'seagull/foundations/colors.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const STEP = 0.1;
const START_VALUE = 7.8;
const END_VALUE = 92.2;
const START_COLOR = (_colors$purple700$mat = colors.purple700.match(/\w{2}/g)) === null || _colors$purple700$mat === void 0 ? void 0 : _colors$purple700$mat.map(hex => Number.parseInt(hex, 16));
const END_COLOR = (_colors$purple800$mat = colors.purple800.match(/\w{2}/g)) === null || _colors$purple800$mat === void 0 ? void 0 : _colors$purple800$mat.map(hex => Number.parseInt(hex, 16));
const LINEAR_SCALE = END_COLOR && (START_COLOR === null || START_COLOR === void 0 ? void 0 : START_COLOR.map((_, i) => percent => percent * (END_COLOR[i] - START_COLOR[i]) + START_COLOR[i]));
function getValueAndPercent(rawValue) {
  const value = rawValue <= START_VALUE ? START_VALUE : rawValue >= END_VALUE ? END_VALUE : rawValue;
  return [value, (value - START_VALUE) / (END_VALUE - START_VALUE)];
}
const getThumbStyle = disabled => ({
  height: 46,
  width: 46,
  marginTop: 4,
  marginLeft: -23,
  backgroundColor: disabled ? colors.dark120 : colors.dark50,
  '&, &:focus, &:hover': {
    boxShadow: "0px 1px 1px ".concat(colors.purple900)
  }
});
const useStyles = makeStyles({
  root: {
    height: 54,
    color: 'currentColor'
  },
  thumb: _objectSpread(_objectSpread({}, getThumbStyle(false)), {}, {
    '&.Mui-disabled': getThumbStyle(true)
  }),
  rail: {
    background: _ref => {
      let {
        disabled
      } = _ref;
      return disabled ? "linear-gradient(90deg, ".concat(colors.dark700, " 0%, #B7B3C5 99.83%, #8873D4 100%)") : "linear-gradient(90deg, ".concat(colors.purple800, " 0%, currentColor 100%)");
    },
    height: 54,
    borderRadius: 90,
    opacity: 1
  }
});
export function SignSlider(_ref2) {
  let {
    onSign,
    onChange,
    disabled
  } = _ref2;
  const styles = useStyles({
    disabled
  });
  const [value, setValue] = useState(START_VALUE);
  const [percent, setPercent] = useState(0);
  const currentColor = useMemo(() => '#' + (LINEAR_SCALE === null || LINEAR_SCALE === void 0 ? void 0 : LINEAR_SCALE.map(fn => Math.floor(fn(percent)).toString(16)).join('')), [percent]);
  return /*#__PURE__*/_jsx("div", {
    style: {
      color: currentColor
    },
    children: /*#__PURE__*/_jsx(Slider, {
      disabled: disabled,
      value: value,
      classes: styles,
      valueLabelDisplay: "off",
      track: false,
      step: STEP,
      onChange: function (_onChange) {
        function onChange(_x, _x2) {
          return _onChange.apply(this, arguments);
        }
        onChange.toString = function () {
          return _onChange.toString();
        };
        return onChange;
      }((_, rawValue) => {
        if (isNumber(rawValue)) {
          const [value, percent] = getValueAndPercent(rawValue);
          setValue(value);
          setPercent(percent);
          onChange(percent);
        }
      }),
      onChangeCommitted: (_, rawValue) => {
        if (isNumber(rawValue)) {
          const [, percent] = getValueAndPercent(rawValue);
          if (percent >= 1) {
            onSign();
          }
        }
      }
    })
  });
}